import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { BlockTypes } from '../../types/api/Block';

type BlockContext<T extends BlockTypes = BlockTypes> = {
  elementType: T;
  uuid: string;
  fetchUrl: string;
  blockLayout?: string;
};

export const BlockContext = createContext<BlockContext | undefined>(undefined);

export const useBlockContext = <T extends BlockTypes = BlockTypes>() => {
  const value = useContext(BlockContext) as BlockContext<T>;
  if (value === undefined) {
    throw Error('BlockContext is used without Provider');
  }
  return value;
};
export function BlockContextProvider({
  elementType,
  uuid,
  fetchUrl,
  blockLayout,
  children,
}: PropsWithChildren<BlockContext>) {
  const blockContext = useMemo(
    () => ({
      elementType,
      uuid,
      fetchUrl,
      blockLayout,
    }),
    [elementType, fetchUrl, blockLayout, uuid],
  );
  return <BlockContext.Provider value={blockContext}>{children}</BlockContext.Provider>;
}
